<script setup>
import { ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import ExamPanel from '@/components/assessment/ExamPanel.vue'
// 나의강의실에서 여는 시험 화면. 학습창 다이얼로그와 같은 전체 화면을 쓴다(사이트 머리글·바닥글 없음).
const route = useRoute(), router = useRouter(), panel = ref(null)
useHead({ title: '시험 응시 · TECHEDU' })
function close() { if (window.history.state?.back) router.back(); else router.push('/my') }
onBeforeRouteLeave(() => !panel.value?.unsaved() || window.confirm('저장되지 않은 답안이 있을 수 있습니다. 시험을 시작했다면 페이지를 나가도 제한시간은 계속됩니다. 이동할까요?'))
</script>
<template><ExamPanel ref="panel" :enroll="Number(route.params.enroll)" :assignment="route.params.assignment" @close="close" /></template>
